"use client";

import { LanguageContext } from "@/context/languageContext";
import { useContext, useEffect } from "react";
import { Room } from "@/types/wordpress";
import { notFound } from "next/navigation";
import { ContentComponent } from "@/types/modules";
import Splash from "../Splash";
import Content from "../Content";
import Checkboxes from "./Checkboxes";
import ViewAll from "../ViewAll";
import Featured from "../Featured";
import { translate } from "@/utils/translate";
import { useLanguageUrl } from "@/context/languageURLContext";

interface RoomComponentProps {
  room: Room;
}

export default function RoomComponent({ room }: RoomComponentProps) {
  const { language } = useContext(LanguageContext);
  const { setUrl } = useLanguageUrl(); // Access context values

  useEffect(() => {
    setUrl(room.translations[0].uri);
  }, [room.translations, setUrl]);

  if (room === null) {
    notFound();
  }

  const content: ContentComponent = {
    imageAlign: room.contentFields.imageAlign || undefined,
    textAlign: room.contentFields.textAlign || undefined,
    content: room.contentFields.body || null,
    gallery: room.contentFields.gallery || undefined,
    button: room.contentFields.button || undefined,
    ...(room.contentFields.title && {
      title: room.contentFields.title,
    }),
  };

  return (
    <>
      {room.slider && room.slider.slider && (
        <Splash slider={room.slider.slider} />
      )}
      <section className="content">
        <div className="contentContainer">
          <Content content={content} />
        </div>
      </section>
      <Checkboxes room={room} />
      <ViewAll
        text={translate["viewAllRooms"][language]}
        link={`/${language}/rooms`}
      />
      <Featured featured={room.featured} />
    </>
  );
}
